<!--
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-21 08:14
 * @LastEditTime: 2024-08-02 09:23:22
 * @LastEditors: 李一哲 3564725715@qq.com
 * @FilePath: \web\src\components\Home\auctionProcess\index.vue
-->
<template>
  <div class="process">
    <!--拍卖流程 -->
    <div class="process-flow wrap">
      <h1>拍卖会流程</h1>
      <div class="process-flow-images">
        <div
          class="process-flow-images-img"
          v-for="(item, index) in list"
          :key="item.id"
        >
          <div class="process-flow-images-item">
            <div class="imageUrl">
              <img class="imageUrl-img1" :src="item.url" alt="" />
              <!-- 每一个item项 -->
              <h3 class="label">{{ item.text }}</h3>
              <p>{{ item.detail }}</p>
              <p>{{ item.view }}</p>
            </div>
            <div class="imageUrls" v-if="item.arrow">
              <img class="imageUrl-img2" :src="item.arrow" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          id: 1,
          text: "注册会员",
          detail: "下载APP",
          view: "免费注册",
          url: "/process/img9.png",
          arrow: "/process/img6.png",
        },
        {
          id: 2,
          text: "查看车辆信息",
          detail: "app筛选、查看",
          url: "/process/img1.png",
          arrow: "/process/img6.png",
        },
        {
          id: 3,
          text: "资质认证",
          detail: "上传身份证信息",
          url: "/process/img10.png",
          arrow: "/process/img6.png",
        },
        {
          id: 4,
          text: "保证金交/退款",
          detail: "3000元/5000元",
          view: "10000元",
          url: "/process/img3.png",
          arrow: "/process/img6.png",
        },
        {
          id: 5,
          text: "线上竞拍",
          detail: "中标提车",
          view: "未中标退款",
          url: "/process/img7.png",
          arrow: "/process/img6.png",
        },
        {
          id: 6,
          text: "中标实地验车",
          detail: "联系网点人员",
          url: "/process/img8.png",
          arrow: "/process/img6.png",
        },
        {
          id: 7,
          text: "交付车款",
          detail: "48小时内完成",
          url: "/process/img3.png",
          arrow: "/process/img6.png",
        },
        {
          id: 8,
          text: "完成提车",
          detail: "3日内完成",
          url: "/process/img5.png",
          arrow: "/process/img6.png",
        },
        {
          id: 9,
          text: "完成过户",
          detail: "规定时效内",
          url: "/process/img2.png",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.process {
  .process-flow {
    height: 300px;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    h1 {
      text-align: center;
      font-size: 24px;
    }

    .process-flow-images {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;

      .process-flow-images-img {
        .process-flow-images-item {
          display: flex;
          justify-content: space-around;
          //align-items: center;
          width: 133.33px;
          line-height: 25px;

          h3 {
            font-size: 16px;
            font-weight: 900;
          }

          p {
            font-size: 14px;
            color: rgb(152, 152, 152);
          }

          .imageUrl {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            .label {
              width: 110px;
              text-align: center;
            }

            .imageUrl-img1 {
              width: 50px;
              height: 50px;
              margin-bottom: 5px;
            }
          }

          .imageUrls {
            .imageUrl-img2 {
              width: 22px;
              height: 20px;
              margin-top: 16px;
              margin-left: 5px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
</style>